import React, { createContext, useContext, useState, useMemo } from 'react';

type PermissionsType = string[] | any;

interface PermissionsContextValue {
  permissions: PermissionsType;
  setPermissions: (perms: PermissionsType) => void;
}

const PermissionsContext = createContext<PermissionsContextValue>({
  permissions: [],
  setPermissions: () => {},
});

export const usePermissions = () => useContext(PermissionsContext);

export const PermissionsProvider = ({ children }: { children: React.ReactNode }) => {
  const [permissions, setPermissions] = useState<PermissionsType>([]);

  // FIX: memoize context value
  const value = useMemo(
    () => ({
      permissions,
      setPermissions,
    }),
    [permissions]
  );

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
};
